{% block sw_cms_element_acris_blog_product_slider_config %}
    <div class="sw-cms-el-config-acris-blog-product-slider">
        {% block sw_cms_element_acris_blog_product_slider_config_settings %}
            <div class="sw-cms-el-config-acris-blog-product-slider__tab-settings-display">
                {% block sw_cms_element_acris_blog_product_slider_config_settings_display_mode %}
                    <mt-select
                            v-model="element.config.displayMode.value"
                            class="sw-cms-el-config-acris-blog-product-slider__tab-settings-display-mode"
                            :label="$tc('sw-cms.elements.general.config.label.displayMode')"
                            :help-text="$tc('sw-cms.elements.productSlider.config.helpText.displayMode')"
                            :options="displayModeOptions"
                    />
                {% endblock %}
            </div>

            <div class="sw-cms-el-config-acris-blog-product-slider__tab-settings-alignment has--two-elements">
                {% block sw_cms_element_acris_blog_product_slider_config_settings_min_width %}
                    <mt-text-field
                            v-model="element.config.elMinWidth.value"
                            class="sw-cms-el-config-acris-blog-product-slider__tab-settings-alignment-min-width"
                            :label="$tc('sw-cms.elements.productSlider.config.label.minWidth')"
                            :placeholder="$tc('sw-cms.elements.productSlider.config.placeholder.minWidth')"
                            :help-text="$tc('sw-cms.elements.productSlider.config.helpText.minWidth')"
                    />
                {% endblock %}

                {% block sw_cms_element_acris_blog_product_slider_config_settings_vertical_align %}
                    <mt-select
                            v-model="element.config.verticalAlign.value"
                            class="sw-cms-el-config-acris-blog-product-slider__tab-settings-alignment-vertical"
                            :label="$tc('sw-cms.elements.general.config.label.verticalAlign')"
                            :placeholder="$tc('sw-cms.elements.general.config.label.verticalAlign')"
                            :options="alignmentOptions"
                    />
                {% endblock %}
            </div>

            <div class="sw-cms-el-config-acris-blog-product-slider__tab-settings-layout has--two-elements">
                {% block sw_cms_element_acris_blog_product_slider_config_settings_box_layout %}
                    <mt-select
                            v-model="element.config.boxLayout.value"
                            class="sw-cms-el-config-acris-blog-product-slider__tab-settings-layout-type"
                            :label="$tc('sw-cms.elements.productBox.config.label.layoutType')"
                            :options="boxLayoutOptions"
                    />
                {% endblock %}

                {% block sw_cms_element_acris_blog_product_slider_config_settings_border %}
                    <mt-switch
                            v-model="element.config.border.value"
                            class="sw-cms-el-config-acris-blog-product-slider__tab-settings-layout-border"
                            :label="$tc('sw-cms.elements.productSlider.config.label.border')"
                            bordered
                    />
                {% endblock %}
            </div>

            <div class="sw-cms-el-config-acris-blog-product-slider__tab-settings-navigation">
                {% block sw_cms_element_acris_blog_product_slider_config_settings_navigation_arrows %}
                    <mt-select
                            v-model="element.config.navigationArrows.value"
                            class="sw-cms-el-config-acris-blog-product-slider__tab-settings-navigation-arrows"
                            :label="$tc('sw-cms.elements.productSlider.config.label.navigationArrows')"
                            :options="arrowOptions"
                            @update:model-value="emitUpdateEl"
                    />
                {% endblock %}
            </div>

            <div class="sw-cms-el-config-acris-blog-product-slider__tab-settings-speed">
                {% block sw_cms_element_acris_blog_product_slider_config_settings_speed %}
                    <mt-number-field
                            v-model="element.config.speed.value"
                            class="sw-cms-el-config-acris-blog-product-slider__tab-settings-speed"
                            number-type="int"
                            :min="0"
                            :max="3600000"
                            :label="$tc('sw-cms.elements.general.config.label.speed')"
                            :placeholder="$tc('sw-cms.elements.general.config.label.speed')"
                            :help-text="$tc('sw-cms.elements.general.config.helpText.speed')"
                    />
                {% endblock %}
            </div>

            <mt-banner
                    class="sw-cms-el-config-acris-blog-product-slider__tab-settings-rotate"
                    variant="attention"
                    :title="$tc('sw-cms.elements.general.config.infoText.autoSlideTitle')"
            >
                <p class="sw-cms-el-config-acris-blog-product-slider__tab-settings-rotate-attention">
                    {{ $tc('sw-cms.elements.general.config.infoText.autoSlide') }}
                </p>

                <div class="sw-cms-el-config-acris-blog-product-slider__tab-settings-rotate-config has--two-elements">
                    {% block sw_cms_element_acris_blog_product_slider_config_settings_rotate %}
                        <mt-switch
                                v-model="element.config.rotate.value"
                                class="sw-cms-el-config-acris-blog-product-slider__tab-settings-rotate-switch"
                                :label="$tc('sw-cms.elements.general.config.label.autoSlide')"
                                bordered
                        />
                    {% endblock %}

                    {% block sw_cms_element_acris_blog_product_slider_config_settings_autoplay_timeout %}
                        <mt-number-field
                                v-model="element.config.autoplayTimeout.value"
                                class="sw-cms-el-config-acris-blog-product-slider__tab-settings-rotate-autoplay"
                                number-type="int"
                                :min="0"
                                :max="3600000"
                                :label="$tc('sw-cms.elements.general.config.label.autoplayTimeout')"
                                :placeholder="$tc('sw-cms.elements.general.config.label.autoplayTimeout')"
                                :help-text="$tc('sw-cms.elements.general.config.helpText.autoplayTimeout')"
                        />
                    {% endblock %}
                </div>
            </mt-banner>
        {% endblock %}
    </div>
{% endblock %}